/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Notifications_Push_TitleInputs */

const id_notifications_push_title = /** @type {(inputs: Notifications_Push_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notifikasi Push`)
};

const ms_notifications_push_title = /** @type {(inputs: Notifications_Push_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pemberitahuan Push`)
};

const da_notifications_push_title = /** @type {(inputs: Notifications_Push_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Push Notifikationer`)
};

const de_notifications_push_title = /** @type {(inputs: Notifications_Push_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Push-Benachrichtigungen`)
};

const en_us2_notifications_push_title = /** @type {(inputs: Notifications_Push_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Push Notifications`)
};

const es_es2_notifications_push_title = /** @type {(inputs: Notifications_Push_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notificaciones Push`)
};

const es_mx2_notifications_push_title = /** @type {(inputs: Notifications_Push_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notificaciones Push`)
};

const fil_notifications_push_title = /** @type {(inputs: Notifications_Push_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Push Notifications`)
};

const fr_notifications_push_title = /** @type {(inputs: Notifications_Push_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notifications Push`)
};

const it_notifications_push_title = /** @type {(inputs: Notifications_Push_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notifiche Push`)
};

const hu_notifications_push_title = /** @type {(inputs: Notifications_Push_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Push értesítések`)
};

const nl_notifications_push_title = /** @type {(inputs: Notifications_Push_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pushmeldingen`)
};

const no_notifications_push_title = /** @type {(inputs: Notifications_Push_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Push-varsler`)
};

const pl_notifications_push_title = /** @type {(inputs: Notifications_Push_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Powiadomienia Push`)
};

const pt_br2_notifications_push_title = /** @type {(inputs: Notifications_Push_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Push Notifications`)
};

const pt_notifications_push_title = /** @type {(inputs: Notifications_Push_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notificações Push`)
};

const ro_notifications_push_title = /** @type {(inputs: Notifications_Push_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notificări Push`)
};

const fi_notifications_push_title = /** @type {(inputs: Notifications_Push_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Push-ilmoitukset`)
};

const sv_notifications_push_title = /** @type {(inputs: Notifications_Push_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Push-notiser`)
};

const vi_notifications_push_title = /** @type {(inputs: Notifications_Push_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thông báo đẩy`)
};

const tr_notifications_push_title = /** @type {(inputs: Notifications_Push_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Push Bildirimleri`)
};

const cs_notifications_push_title = /** @type {(inputs: Notifications_Push_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Push oznámení`)
};

const bg_notifications_push_title = /** @type {(inputs: Notifications_Push_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Push известия`)
};

const ru_notifications_push_title = /** @type {(inputs: Notifications_Push_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Push-уведомления`)
};

const uk_notifications_push_title = /** @type {(inputs: Notifications_Push_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Push-сповіщення`)
};

const ar_notifications_push_title = /** @type {(inputs: Notifications_Push_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الإشعارات الفورية`)
};

const hi_notifications_push_title = /** @type {(inputs: Notifications_Push_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`पुश सूचनाएँ`)
};

const th_notifications_push_title = /** @type {(inputs: Notifications_Push_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`การแจ้งเตือนแบบพุช`)
};

const ja_notifications_push_title = /** @type {(inputs: Notifications_Push_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`プッシュ通知`)
};

const zh_cn2_notifications_push_title = /** @type {(inputs: Notifications_Push_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Push Notifications`)
};

const zh_hant1_notifications_push_title = /** @type {(inputs: Notifications_Push_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Push Notifications`)
};

const ko_notifications_push_title = /** @type {(inputs: Notifications_Push_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`푸시 알림`)
};

/**
* | output |
* | --- |
* | "Push Notifications" |
*
* @param {Notifications_Push_TitleInputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const notifications_push_title = /** @type {((inputs?: Notifications_Push_TitleInputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notifications_Push_TitleInputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_notifications_push_title(inputs)
	if (locale === "ms") return ms_notifications_push_title(inputs)
	if (locale === "da") return da_notifications_push_title(inputs)
	if (locale === "de") return de_notifications_push_title(inputs)
	if (locale === "en-US") return en_us2_notifications_push_title(inputs)
	if (locale === "es-ES") return es_es2_notifications_push_title(inputs)
	if (locale === "es-MX") return es_mx2_notifications_push_title(inputs)
	if (locale === "fil") return fil_notifications_push_title(inputs)
	if (locale === "fr") return fr_notifications_push_title(inputs)
	if (locale === "it") return it_notifications_push_title(inputs)
	if (locale === "hu") return hu_notifications_push_title(inputs)
	if (locale === "nl") return nl_notifications_push_title(inputs)
	if (locale === "no") return no_notifications_push_title(inputs)
	if (locale === "pl") return pl_notifications_push_title(inputs)
	if (locale === "pt-BR") return pt_br2_notifications_push_title(inputs)
	if (locale === "pt") return pt_notifications_push_title(inputs)
	if (locale === "ro") return ro_notifications_push_title(inputs)
	if (locale === "fi") return fi_notifications_push_title(inputs)
	if (locale === "sv") return sv_notifications_push_title(inputs)
	if (locale === "vi") return vi_notifications_push_title(inputs)
	if (locale === "tr") return tr_notifications_push_title(inputs)
	if (locale === "cs") return cs_notifications_push_title(inputs)
	if (locale === "bg") return bg_notifications_push_title(inputs)
	if (locale === "ru") return ru_notifications_push_title(inputs)
	if (locale === "uk") return uk_notifications_push_title(inputs)
	if (locale === "ar") return ar_notifications_push_title(inputs)
	if (locale === "hi") return hi_notifications_push_title(inputs)
	if (locale === "th") return th_notifications_push_title(inputs)
	if (locale === "ja") return ja_notifications_push_title(inputs)
	if (locale === "zh-CN") return zh_cn2_notifications_push_title(inputs)
	if (locale === "zh-Hant") return zh_hant1_notifications_push_title(inputs)
	return ko_notifications_push_title(inputs)
});
export { notifications_push_title as "notifications.push.title" }